module.exports = __webpack_public_path__ + "media/bootstrap-icons/signpost-split-737dd02b.svg";